import { useCallback } from "react"

import { LOGIN_OVERLAY, LOGOUT_OVERLAY } from "shared/context/overlay/types"
import { useOverlay } from "shared/lib/useOverlay"

import { AuthenticationHandlers } from "../types/AuthenticationHandlers"

/**
 * Hook that provides authentication handlers for login and logout operations.
 * Uses overlay system to display login and logout modals.
 *
 * @returns {AuthenticationHandlers} Object containing login and logout functions
 */
export function useAuthenticationHandlers(): Required<AuthenticationHandlers> {
  const { openOverlay: openLoginOverlay } = useOverlay(LOGIN_OVERLAY)
  const { openOverlay: openLogoutOverlay } = useOverlay(LOGOUT_OVERLAY)

  const login = useCallback(() => {
    openLoginOverlay(null)
  }, [openLoginOverlay])

  const logout = useCallback(() => {
    openLogoutOverlay(null)
  }, [openLogoutOverlay])

  return {
    login,
    logout
  }
}
